module.exports = __webpack_public_path__ + "static/img/honor17.62c54a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/honor/honor17.jpg
// module id = dgzW
// module chunks = 1